import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const OK = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const mailTo = async (path, suggested, what, onSent) => {
  const m = window.prompt(`Email a cui inviare ${what}`, suggested || "");
  if (m === null) return;
  if (!OK.test(m.trim())) return toast.error("Email non valida");
  try { await api.post(path, { email: m.trim() }); toast.success(`Inviato a ${m.trim()}`); onSent?.(); } catch (e) { toast.error(errMsg(e)); }
};

export const MailButton = ({ path, email, what, testid, label, icon, onSent }) => (
  <Button variant={icon ? "ghost" : "outline"} size={icon ? "icon" : "default"} className={icon ? "" : "bg-white"} title={`Invia ${what} via email`}
    data-testid={testid} onClick={() => mailTo(path, email, what, onSent)}>
    <Mail className={icon ? "h-4 w-4" : "mr-2 h-4 w-4"} />{!icon && label}
  </Button>
);
